import { useSWRConfig } from "swr";
import useMutation from "hooks/useMutation";
import OneRepMaxService from "services/OneRepMaxService";
import { getOneRepMaxesByAthleteIdsCacheKeyMatcher } from "hooks/useGetOneRepMaxesByAthleteIdsQuery";
import { getAthleteOneRepMaxesCacheKeyMatcher } from "hooks/useGetAthleteOneRepMaxesQuery";

/**
 * Deletes a manual 1RM by id, then revalidates every cached 1RM list that could include it.
 */
function useOneRepMaxDeleteMutation(athleteId: string) {
  const { mutate } = useSWRConfig();
  const key = athleteId ? (["OneRepMaxService.deleteByOneRepMaxId", athleteId] as const) : null;

  return useMutation<unknown, Error, typeof key, string>(key, async ([, aid], { arg: oneRepMaxId }) => {
    const result = await OneRepMaxService.deleteByOneRepMaxId(aid, oneRepMaxId);
    const matchers = [getOneRepMaxesByAthleteIdsCacheKeyMatcher(), getAthleteOneRepMaxesCacheKeyMatcher(aid)];
    await mutate((cacheKey) => matchers.some((matches) => matches(cacheKey)));
    return result;
  });
}

export default useOneRepMaxDeleteMutation;
